export const TURNSTILE_STAGING_SITE_KEY = '0x4AAAAAAAFIVRgDLKmxZX82';
export const TURNSTILE_PRODUCTION_SITE_KEY = '0x4AAAAAAAFIUlKyH502xmcr';
